import { ResignationRequestFormResponse } from '@Types/api/form';
import { RequestFormHeader } from '@Types/index';

export const prepareFormHeaderData = (
  formData: ResignationRequestFormResponse | undefined
): RequestFormHeader | undefined => {
  if (!formData) {
    return undefined;
  }

  return {
    reqStatusId: formData.statusId,
    createdDate: formData.createdDate,
    requestId: formData.requestId,
  };
};
